module.exports = __webpack_public_path__ + "static/img/Coffee Bean.defbbd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Coffee Bean.jpg
// module id = lsOw
// module chunks = 0